import React from 'react';
import { uniq } from 'lodash';
import { MultiValueChips, SelectedCount } from './MultiValueChips';
import { RenderValueTypes } from './select-consts';
import * as S from './styled';

export const renderCommaSeparated = selected => (
  <S.MultiValueCommaSeparatedContainer>
    {selected.map(s => s.label || s).join(', ')}
  </S.MultiValueCommaSeparatedContainer>
);

export const buildRenderer = ({ renderValue, chipsCount, value, multiple, optionsByValue, testId, clearValue }) => {
  if (typeof renderValue === 'function') return renderValue;

  if (!multiple) return null;

  if (renderValue === RenderValueTypes.COMMA_SEPARATED) {
    return renderCommaSeparated;
  }
  if (renderValue === RenderValueTypes.CHIPS) {
    return () => (
      <MultiValueChips
        optionsByValue={optionsByValue}
        values={value}
        count={chipsCount}
        clearValue={clearValue}
        testId={`chips-${testId}`}
      />
    );
  }
  if (renderValue === RenderValueTypes.COUNT) {
    return () => <SelectedCount optionsByValue={optionsByValue} values={value} />;
  }
};

export const spreadHierarchicalSelection = ({ values, optionsByValue }) => {
  let removedValues = [];
  const newValues = values.reduce((acc, v) => {
    const subVals = optionsByValue[v]?.children?.map(c => c.value);
    if (subVals?.every(subVal => values.includes(subVal))) {
      removedValues = [...removedValues, ...subVals];
      return acc;
    }
    if (subVals) {
      return [...acc, ...subVals];
    }
    return [...acc, v];
  }, []);

  return uniq(newValues).filter(v => !removedValues.includes(v));
};

export const mapSubOptions = options =>
  options.flatMap(o => [o, ...(o.children?.map(c => ({ ...c, sub: true })) || [])]);
